import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const profilePageContext = React.createContext({});
export let profilePageMachine: any;

export const useSMProfilePageGetContent = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  profilePageMachine = createMachine(_machineConfig, { services, actions });
  const [state, send] = useMachine(profilePageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    profilePageMachine,
    profilePageState: state,
    profilePageSend: send,
  };
};
